import { type AxiosResponse } from 'axios'
import axiosService from './AxiosService'

const request = {
  get<T>(url: string, params = {}, options: { headers?: any } = {}) {
    return axiosService<T, AxiosResponse<T>>({
      url: url,
      method: 'GET',
      params: params,
      headers: options.headers,
    })
  },

  post<T>(url: string, params = {}) {
    return axiosService<T, AxiosResponse<T>>({
      url: url,
      method: 'POST',
      data: params,
    })
  },

  put<T>(url: string, params = {}) {
    return axiosService<T, AxiosResponse<T>>({
      url: url,
      method: 'PUT',
      data: params,
    })
  },

  delete<T>(url: string, params = {}) {
    return axiosService<T, AxiosResponse<T>>({
      url: url,
      method: 'DELETE',
      data: params,
    })
  },

  // TODO: これらは RequestService の責務を超えているように思うので分離したい
  getParam(keyParam: string) {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    return urlParams.get(keyParam)
  },

  getAllParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const params: { [key: string]: string } = {};

    for (const [key, value] of urlParams) {
      params[key] = value;
    }

    return params;
  }
}

export default request
